import { render, staticRenderFns } from "./paper-citation-popup.html?vue&type=template&id=3430c23c&scoped=true&external"
import script from "./paper-citation-popup.js?vue&type=script&lang=js&external"
export * from "./paper-citation-popup.js?vue&type=script&lang=js&external"
import style0 from "./paper-citation-popup.scss?vue&type=style&index=0&id=3430c23c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3430c23c",
  null
  
)

export default component.exports